import React from 'react';
import _ from 'underscore';
import { Button, Grid, Divider, Segment, Header, Input, Item, Loader, GridRow, Message } from 'semantic-ui-react';

import ClinicListSearchBar from '../../../clinic/clinic_list_search_bar';
import ClinicListFilterByType from '../../../clinic/clinic_list_filter/clinic_list_filter_by_type';
import ClinicListFilterByArea from '../../../clinic/clinic_list_filter/clinic_list_filter_by_area';
import ClinicListFilterByCompany from '../../../clinic/clinic_list_filter/clinic_list_filter_by_company';
import ClinicList from '../../../clinic/clinic_list';
import ClinicListItem from '../../../clinic/clinic_list_item';


class UserFormPanelClinics extends React.Component {
    state = {
        mode: this.props.selection ? this.props.selection.mode : 1, // 1 - browse, 2 - view one after search
        selectedClinicObjectKey: this.props.selection ? this.props.selection.selectedClinicObjectKey : null
    }

    updateMode(mode, selectedClinicObjectKey) {
        if (mode === 3) {
            this.props.updateClinicSelection({mode, selectedClinicObjectKey: null});
        }
        if (mode === 2) {
            this.props.updateClinicFilterOptions({filterByType: null, filterByArea: null});
            this.props.updateClinicSelection({mode, selectedClinicObjectKey});
        } else {
            this.props.updateClinicSelection({mode, selectedClinicObjectKey: null});
        }
    }

    render() {
        console.log('PROPS', this.props)
        let clinicsToDisplay = this.props.clinics;

        if (this.state.mode === 2) {
            clinicsToDisplay = [this.props.clinics[this.state.selectedClinicObjectKey]]
        } else if (this.state.mode === 3) {
            // filter list based on type and area
            const {filterByType, filterByArea} = this.props.filterOptions;
            if (filterByType || filterByType === 0) {
                clinicsToDisplay = _.filter(clinicsToDisplay, (clinic) => clinic.t === filterByType);
            }
            if (filterByArea) {
                clinicsToDisplay = _.filter(clinicsToDisplay, (clinic) => clinic.ar === filterByArea);
            }
        }
        
        return (
            <Segment>
                <Grid container columns={1}>
                    <Grid.Column width={16}>
                        <Divider horizontal style={{ margin: "13px 0 0 0" }}> <Header as='h3'>Panel Clinics</Header></Divider>
                    </Grid.Column>    
                </Grid>
                <Grid>
                    <Grid.Row columns={16}>
                        <Grid.Column width={4}>
                            <ClinicListFilterByCompany 
                                user={this.props.users}
                                filterOptions={this.props.filterOptions}
                                updateClinicFilterOptions={this.props.updateClinicFilterOptions}
                                updateMode={this.updateMode.bind(this)}
                            />
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <ClinicListFilterByType 
                                typeList={this.props.typeList}
                                filterOptions={this.props.filterOptions}
                                updateClinicFilterOptions={this.props.updateClinicFilterOptions}
                                updateMode={this.updateMode.bind(this)}
                            />
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <ClinicListFilterByArea 
                                areaList={this.props.areaList}
                                filterOptions={this.props.filterOptions}
                                updateClinicFilterOptions={this.props.updateClinicFilterOptions}
                                updateMode={this.updateMode.bind(this)}
                            />
                        </Grid.Column>
                        { this.props.clinics.length > 0 &&
                        <Grid.Column width={4}>
                            <Button style={{width:175}} onClick={() => this.props.downloadClinicLoading ? "" : this.props.downloadClinicListBySysAdmin(this.props.user.accessToken, this.props.filterOptions.filterByCompany, this.props.filterOptions.filterByType, this.props.users.nric)} loading={this.props.downloadClinicLoading} color="blue" icon="download" content="Download clinics"/>
                            { this.props.downloadClinicError &&
                            <Message negative>
                                <p>
                                    { "Download failed" }
                                </p>
                            </Message> }
                        </Grid.Column> }
                    </Grid.Row>
                    <Grid.Row columns={16}>
                        <Grid.Column width={16}>
                            <ClinicListSearchBar 
                                clinics={this.props.clinics}
                                updateMode={this.updateMode.bind(this)}
                                mode={this.state.mode}
                                updateClinicFilterOptions={this.props.updateClinicFilterOptions}
                                updateClinicSearchValue={this.props.updateClinicSearchValue}
                                searchValue={this.props.searchValue}
                                role='sys-admin'
                            />
                        </Grid.Column>
                    </Grid.Row>
                    { this.props.isLoadingClinic &&
                    <Grid.Row>
                        <div style={{margin: "20px 0 20px 0"}}>
                            <Loader active={this.props.isLoadingClinic} />
                        </div>
                    </Grid.Row> }
                    {!this.props.isLoadingClinic &&
                    <Grid.Row>
                        <Grid.Column>
                            <div style={{height:"65vh", overflowY:"auto"}}>
                            {
                                (this.state.mode === 1) ? 
                                (
                                    <ClinicList 
                                        clinics={clinicsToDisplay}
                                        mode={this.state.mode}
                                        role='sys-admin'
                                    />
                                )
                                :
                                (this.state.mode === 2) ?
                                (
                                    <Segment>
                                        <Item.Group divided>
                                            <ClinicListItem
                                                data={clinicsToDisplay[0]}
                                            />
                                        </Item.Group>
                                    </Segment>
                                )
                                :
                                (
                                    <ClinicList 
                                        clinics={clinicsToDisplay}
                                        mode={this.state.mode}
                                        role='sys-admin'
                                    />
                                )
                            }
                            </div>
                        </Grid.Column>
                    </Grid.Row>}
                </Grid>
            </Segment>
        );

    }

}

UserFormPanelClinics.defaultProps = {
    users: {},
    admin: {},
    onSubmit: undefined,
    renderSubmitResult: undefined,
    submitText: "Save"
}

export default UserFormPanelClinics;
